<script>
  import { currentUser, cache, formatNumber } from '../utils';
  import Chart from './Chart.svelte';

  import Table from './Table.svelte';
  import { getLastXDays, dateFormat } from '../utils.js';
  import { LogoLoader } from '@shopboxai/sb-portal-components';
  export let key;
  export let startDate = getLastXDays(7, dateFormat).startDate;
  export let endDate = getLastXDays(7, dateFormat).endDate;
  export let device = null;

  let fetchReport = async (key) => {
    let url = `https://reports.shopbox.ai/reports_async/${$currentUser.fullClientId}?report_name=${key}`;
    if (startDate != null && endDate != null) {
      url += `&start_date=${startDate}&end_date=${endDate}`;
    }
    if (device != null) {
      url += `&device=${device}`;
    }
    // check if cache exists for this url
    if ($cache[url]) {
      return $cache[url];
    }
    const res = await fetch(url);
    let json = await res.json();
    // if value passes, store url in cache
    if (json) {
      $cache[url] = json;
    }

    return json;
  };

  let runFetchReport;
  $: if (device || startDate || endDate) {
    console.log('fetch', $currentUser);

    runFetchReport = fetchReport(key);
  }
</script>

{#await runFetchReport}
  <div class="loader">
    <LogoLoader />
  </div>
{:then chartConfigs}
  <div class="chart-grid">
    {#if chartConfigs}
      {#each Object.entries(chartConfigs) as [x, y]}
        {#if y['type'] === 'data_table'}
          <div class=" sbTable">
            <Table rows={y['data_table_rows']} columns={y['columns']} />
          </div>
        {:else if y['type'] === 'number'}
          <div class="hnc">
            <p class="title">{y.title}</p>
            <h2>{formatNumber(y.value, y.format)}</h2>
            <p class="info">{y.subtitle}</p>
          </div>
        {:else}
          <div class="chart">
            <Chart config={y} />
          </div>
        {/if}
      {/each}
    {/if}
  </div>
{:catch error}
  <p class="error-msg">No data available yet.</p>
{/await}

<style>.chart-grid{display:grid;gap:2em 1em;grid-template-columns:repeat(12,1fr);margin-inline:auto;min-height:calc(90vh - 50px);overflow-y:auto;padding:.5em;position:relative}.sbTable{grid-column:span 12}.chart{grid-column:span 6;min-height:400px}.hnc{grid-column:span 4}.chart,.hnc,.sbTable{border-radius:2px;box-shadow:0 0 8px -2px rgba(24,39,75,.12),0 4px 4px -2px rgba(24,39,75,.16);padding:1em}.hnc{display:grid;grid-template-rows:-webkit-min-content 1fr 2em;grid-template-rows:min-content 1fr 2em;min-height:150px}.hnc h2{align-self:end;color:var(--p-c);font-family:Chivo;font-size:34px;font-style:normal;font-weight:900}.hnc .title{font-size:16px;font-weight:800;letter-spacing:.1px;line-height:20px}.hnc .info{align-self:flex-end;color:#43414b;font-size:14px;font-weight:400;letter-spacing:.15px;line-height:18px}.error-msg{margin-top:1em}@media (max-width:1100px){.hnc h2{font-size:32px}.chart{grid-column:span 12}}@media (max-width:980px){.hnc{grid-column:span 6}.chart{min-height:350px}}@media (max-width:550px){.hnc{grid-column:span 12}}.loader{left:50%;position:absolute;top:400px;transform:translateX(-50%) scale(2)}</style>
